export default "__VITE_ASSET__CWwX7Zd8__"